import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IWebviewWorkbenchService = ( createDecorator('webviewEditorService'));
export { IWebviewWorkbenchService };
